module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search":"Search predefined KPIs","selected":"Selected KPIs","unsubmittedAlert":"{count} KPI(s) selected but not yet submitted: {names}"},"de":{"search":"Vordefinierte KPIs suchen","selected":"Ausgewählte KPIs","unsubmittedAlert":"{count} KPI(s) ausgewählt, aber noch nicht eingereicht: {names}"}}')
  delete Component.options._Ctor
}
